import { useState as m, useCallback as t } from "react";
function b() {
  let g = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  let [r, l] = m(g),
    u = t(e => l(a => a | e), [l]),
    n = t(e => Boolean(r & e), [r]),
    o = t(e => l(a => a & ~e), [l]),
    s = t(e => l(a => a ^ e), [l]);
  return {
    addFlag: u,
    hasFlag: n,
    removeFlag: o,
    toggleFlag: s
  };
}
export { b as useFlags };